const defaultProps = {
  size: "lg",
};

const CloseButton = {
  defaultProps,
};

export default CloseButton;
